import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimationProp, FontAwesomeModule, SizeProp } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/angular-fontawesome/types';

@Component({
  selector: 'orbit-fa-icon',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './fa-icon.component.html',
  styleUrl: './fa-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaIconComponent {
  public iconName = input.required<IconProp>();
  public iconColor = input<string | undefined>(undefined);
  public iconSize = input<SizeProp | undefined>('1x');
  public animation = input<AnimationProp | undefined>(undefined);
}
